
export function getDateTimeString(): string {

    // yyyyMMdd_HHmmss
    const now = new Date();
    const dateStr =
        now.getFullYear() +
        ("00" + (now.getMonth() + 1)).slice(-2) +
        ("00" + now.getDate()).slice(-2) +
        "_" +
        ("00" + now.getHours()).slice(-2) +
        ("00" + now.getMinutes()).slice(-2) +
        ("00" + now.getSeconds()).slice(-2);
    return dateStr;
}

export function startDownload(url: string, filename: string, loaderId: string): void {
    $("#" + loaderId).show();
    kendo.ui.progress($("#moduleLayout"), true);

    fetch(url)
        .then(response => {
            if (!response.ok) {
                throw Error(response.status + ' ' + response.statusText)
            }
            // ensure ReadableStream is supported
            if (!response.body) {
                throw Error('ReadableStream not yet supported in this browser.')
            }
            // store the size of the entity-body, in bytes
            const contentLength = response.headers.get('content-length');
            // ensure contentLength is available
            if (!contentLength) {
                throw Error('Content-Length response header unavailable');
            }
            // Get filename from server response
            var contentDisposition = response.headers.get("content-disposition");
            if (contentDisposition != null) {
                var match = contentDisposition.match(/filename\s*=\s*"?(.+)"?;/);
                filename = match[1];
            }
            // parse the integer into a base-10 number
            const total = parseInt(contentLength, 10);
            let loaded = 0;
            return new Response(
                // create and return a readable stream
                new ReadableStream({
                    start(controller) {
                        const reader = response.body.getReader();
                        read();
                        function read() {
                            reader.read().then(({ done, value }) => {
                                if (done) {
                                    controller.close();
                                    return;
                                }
                                loaded += value.byteLength;
                                progress(loaded, total)
                                controller.enqueue(value);
                                read();
                            }).catch(error => {
                                console.log(error);
                                controller.error(error)
                            })
                        }
                    }
                })
            );
        })
        .then(response =>
            // construct a blob from the data
            response.blob()
        )
        .then(data => {
            // insert the downloaded image into the page
            //document.getElementById('img').src = URL.createObjectURL(data);

            const a = document.createElement('a');
            document.body.appendChild(a);
            const urlData = URL.createObjectURL(data);
            a.href = urlData;
            a.download = filename;
            // We provided a header called Content-Disposition so we dont need to set "a.download" here
            // a.download = fileName || 'download'
            a.click();
            setTimeout(() => {
                $("#" + loaderId).hide();
                kendo.ui.progress($("#moduleLayout"), false);

                window.URL.revokeObjectURL(urlData);
                document.body.removeChild(a);
            }, 0);
        })
        .catch(error => {
            console.log(error);
        })
}

export function progress(loaded: number, total: number): void {
    //const element = document.getElementById('progress');
    //element.innerHTML = Math.round(loaded / total * 100) + '%';
}
